/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myKiosks: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_KIOSKS_DONE:
      return { ...state, myKiosks: action.data.items };
    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'Kiosk') {
        return {
          ...state,
          myKiosks: R.reject((s: any) => s._id === action.itemId, state.myKiosks)
        };
      }

      return state;
    default:
      return state;
  }
}
